export default "__VITE_ASSET__ChQWio7D__"